<block-ui>
    <router-outlet ></router-outlet>

  <ng-container *ngIf="isDownloadPopup">
    <div class="popup-wrapper position-absolute d-flex flex-row-reverse">
      <div class="popup-multi-download d-flex align-items-center">
          <span class="popup-title">
            {{'download_popup.prefixTitle' | translate}}
            <span class="cl-3f97d9 mx-1">{{downloadIds.length}}</span>
            {{'download_popup.suffixTitle' | translate}}
            <span class="cl-3f97d9 ml-1">{{nameMenu | translate}}</span>
          </span>
        <mat-spinner mode="indeterminate" class="loading" [diameter]="20" [strokeWidth]="2"></mat-spinner>
        <span class="close-download" (click)="handleCloseDownload()">
            <mat-icon>close</mat-icon>
          </span>
      </div>
    </div>
  </ng-container>
</block-ui>
